import React from "react";
import { Modal } from "antd";

const ConfirmationModal = ({
  visible,
  message,
  loading,
  onOk,
  onCancel,
  okText = "Yes",
  cancelText = "No",
  title = "Submit Confirmation",
}) => {
  return (
    <Modal
      title={title}
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText={okText}
      cancelText={cancelText}
      confirmLoading={loading}
    >
      <p>{message}</p>
    </Modal>
  );
};

export default ConfirmationModal;
